import React from "react";
import { useNavigate } from "react-router-dom";
import FunctionsIcon from "@mui/icons-material/Functions";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import UploadOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { TbBrandPagekit } from "react-icons/tb";
import { AiOutlineUsergroupDelete } from "react-icons/ai";
import GroupsIcon from "@mui/icons-material/Groups";
export default function AdminOptions() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <h1 className="text-center text-primary m-4">Admin Options</h1>

      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <h4 className="text-center  mt-4">Score Formula</h4>
          <div className="list-group text-center px-5">
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/leaderboard/editFormula")}
              className="list-group-item list-group-item-action "
            >
              <FunctionsIcon color="action" fontSize="medium"></FunctionsIcon>{" "}
              Edit Formula{" "}
            </a>
          </div>

          <h4 className="text-center text-primary mt-5">Management</h4>
          <div className="list-group text-center px-5">
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/edit/problems")}
              className="list-group-item list-group-item-action list-group-item-primary  rounded"
            >
              <ArticleOutlinedIcon
                color="action"
                fontSize="medium"
              ></ArticleOutlinedIcon>{" "}
              Problem Management
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/mentees")}
              class="list-group-item list-group-item-action  list-group-item-primary rounded"
            >
              <ArticleOutlinedIcon
                color="action"
                fontSize="medium"
              ></ArticleOutlinedIcon>{" "}
              Mentee Management
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/batch-management")}
              class="list-group-item list-group-item-action  list-group-item-primary rounded"
            >
              <ArticleOutlinedIcon
                color="action"
                fontSize="medium"
              ></ArticleOutlinedIcon>{" "}
              Batch Management
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/college")}
              class="list-group-item list-group-item-action  list-group-item-primary rounded"
            >
              <ArticleOutlinedIcon
                color="action"
                fontSize="medium"
              ></ArticleOutlinedIcon>{" "}
              College Management
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/criteria")}
              class="list-group-item list-group-item-action  list-group-item-primary rounded"
            >
              <ArticleOutlinedIcon
                color="action"
                fontSize="medium"
              ></ArticleOutlinedIcon>{" "}
              Criteria Management
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/tags")}
              className="list-group-item list-group-item-action list-group-item-primary  rounded"
            >
              <ArticleOutlinedIcon
                color="action"
                fontSize="medium"
              ></ArticleOutlinedIcon>{" "}
              Tag Management
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/courses")}
              className="list-group-item list-group-item-action list-group-item-primary rounded"
            >
              <ArticleOutlinedIcon
                color="action"
                fontSize="medium"
              ></ArticleOutlinedIcon>{" "}
              Course Management
            </a>
          </div>

          <h4 className="text-center text-secondary mt-5">
            Attendance Management
          </h4>
          <div className="list-group text-center  px-5">
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/attendance-session")}
              className="list-group-item list-group-item-action list-group-item-secondary rounded"
            >
              <GroupsIcon color="action" fontSize="medium"></GroupsIcon> &nbsp;
              Attendance Tracker
            </a>
          </div>

          <h4 className="text-center text-success mt-5">Old Admin Pages</h4>
          <div className="list-group text-center  px-5">
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/sites/handles")}
              className="list-group-item list-group-item-action list-group-item-success rounded"
            >
              <TbBrandPagekit
                size={22}
                color="grey"
                fontSize="medium"
              ></TbBrandPagekit>{" "}
              &nbsp; Site Handles Page
            </a>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          <h4 className="text-center text-info mt-4">Reports</h4>
          <div className="list-group text-center rounded  px-5">
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/reports/contest")}
              className="list-group-item list-group-item-action list-group-item-info rounded"
            >
              <SummarizeOutlinedIcon
                color="action"
                fontSize="medium"
              ></SummarizeOutlinedIcon>{" "}
              Contests Reports
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/reports/aggregate/contest")}
              className="list-group-item list-group-item-action list-group-item-info rounded"
            >
              <SummarizeOutlinedIcon
                color="action"
                fontSize="medium"
              ></SummarizeOutlinedIcon>{" "}
              Contests Aggregate Reports
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/reports/problem")}
              className="list-group-item list-group-item-action list-group-item-info rounded"
            >
              <AssessmentOutlinedIcon
                color="action"
                fontSize="medium"
              ></AssessmentOutlinedIcon>{" "}
              Problem Reports
            </a>
          </div>

          <h4 className="text-center text-warning mt-5">Uploads</h4>
          <div className="list-group text-center px-5">
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/upload/vqr")}
              className="list-group-item list-group-item-action list-group-item-warning rounded"
            >
              <UploadOutlinedIcon
                color="action"
                fontSize="medium"
              ></UploadOutlinedIcon>{" "}
              VQR Scores Upload
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/upload/user")}
              className="list-group-item list-group-item-action list-group-item-warning rounded"
            >
              <UploadOutlinedIcon
                color="action"
                fontSize="medium"
              ></UploadOutlinedIcon>{" "}
              Pre-Create / update-user
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/upload/sincerity-score")}
              className="list-group-item list-group-item-action list-group-item-warning rounded"
            >
              <UploadOutlinedIcon
                color="action"
                fontSize="medium"
              ></UploadOutlinedIcon>{" "}
              Sincerity Score Upload
            </a>
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/admin/upload/contest-leaderboard")}
              className="list-group-item list-group-item-action list-group-item-warning rounded"
            >
              <UploadOutlinedIcon
                color="action"
                fontSize="medium"
              ></UploadOutlinedIcon>{" "}
              Upload contest leaderboard
            </a>
          </div>

          <h4 className="text-center text-dark mt-5">User Pages</h4>
          <div className="list-group text-center rounded  px-5">
            <a
              style={{ cursor: "pointer", minWidth: "220px" }}
              onClick={() => navigate("/all/users")}
              className="list-group-item list-group-item-action list-group-item-dark rounded"
            >
              <AiOutlineUsergroupDelete
                size={22}
                color="grey"
                fontSize="medium"
              ></AiOutlineUsergroupDelete>{" "}
              Users
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}